import { FunctionComponent, RefCallback } from "react";
import i18n from "../i18n/index.js";
import { Language } from "../types/index.js";
import { getTranslations } from "../utils/utils.js";
import Icon from "./Icon.js";

interface Props {
  languageId: Language;
  isOpen: boolean;
  onClick: () => void;
  innerRef?: RefCallback<HTMLElement>;
}

const FullMenuButton: FunctionComponent<Props> = ({
  languageId,
  isOpen,
  onClick,
  innerRef,
}) => {
  const { menu } = getTranslations(languageId, i18n);

  return (
    <button
      ref={innerRef}
      onClick={onClick}
      type="button"
      className="Btn--bare FullHeaderOverlay__MenuButton"
    >
      <span className="FullHeaderOverlay__MenuButtonInner">
        <Icon
          className="FullHeaderOverlay__MenuButtonIcon"
          glyph={isOpen ? "close" : "view-headline"}
        />
      </span>
      <span className="FullHeaderOverlay__MenuButtonText">{menu.menu}</span>
    </button>
  );
};

export default FullMenuButton;
